import * as React from "react";
import { useCallback } from "react";

import BoxContainer from "@hl/base-components/lib/BoxContainer";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { Button, Group, Stack, Text } from "@mantine/core";
import { usePrivy, useLinkAccount } from "@privy-io/react-auth";

import {
  PublicUserProfileQuery,
  useLinkFarcasterMutation,
  useUnlinkFarcasterMutation,
} from "../queries/profile.graphql.generated";

export interface Props {
  profile?: PublicUserProfileQuery["getPublicAccountSettings"];
  loading: boolean;
}

export const LinkFarcasterInput = ({ loading }: Props) => {
  const { unlinkFarcaster, user } = usePrivy();

  const [linkFarcasterMutation, { loading: loadingLinkFarcaster }] =
    useLinkFarcasterMutation();

  const [unlinkFarcasterMutation, { loading: loadingUnlinkFarcaster }] =
    useUnlinkFarcasterMutation();

  const { linkFarcaster } = useLinkAccount({
    onSuccess: ({ user, linkMethod }) => {
      if (user?.farcaster?.fid && linkMethod === "farcaster") {
        linkFarcasterMutation();
      }
    },
  });

  const unlinkFarcasterOnClickHandler = useCallback(
    async (fid: number) => {
      await unlinkFarcaster(fid);
      await unlinkFarcasterMutation();
    },
    [unlinkFarcaster, unlinkFarcasterMutation]
  );

  return (
    <Stack spacing={4}>
      <BoxContainer p="8px 16px">
        <Group position="apart">
          <Group spacing={10}>
            <Text
              size="sm"
              color={
                user?.farcaster ? TEXT_COLOR.PRIMARY : TEXT_COLOR.PLACEHOLDER
              }
            >
              {user?.farcaster ? `@${user.farcaster.username}` : "@username"}
            </Text>
          </Group>
          <Button
            component="a"
            target="_blank"
            onClick={
              user?.farcaster?.fid
                ? () => unlinkFarcasterOnClickHandler(user.farcaster?.fid || 0)
                : linkFarcaster
            }
            color={SECONDARY_COLOR}
            size="xs"
            px={12}
            loading={loading || loadingLinkFarcaster || loadingUnlinkFarcaster}
          >
            {user?.farcaster ? "Unlink Farcaster" : "Link Farcaster"}
          </Button>
        </Group>
      </BoxContainer>
    </Stack>
  );
};
